import React, { useContext, useEffect } from "react"
import { QueryClient, QueryClientProvider } from "react-query"
import { Layout } from "../components/atoms/Layout"
import { PageProps } from "gatsby"
import Inventory from "../components/organisms/Inventory"
import { ReactQueryDevtools } from "react-query/devtools"
import { FamilySeriesProvider } from "../contexts/FamilySeries/context"
import FamilySeries from "../components/organisms/Inventory/FamilySeries"
import { FiltersProvider } from "../contexts/Filters/context"
import { ConfirmZipContext } from "../contexts/ConfirmZip"
import { openConfirmZipModal } from "../contexts/ConfirmZip/actions"
import { LocalStorageClient } from "../clients/LocalStorageClient"
import { SEO } from "../components/atoms/SEO"
import { ConfirmZipModal } from "../components/molecules/ConfirmZipModal"
import { LocationContext } from "../contexts/Location"

const queryClient = new QueryClient()

const InventoryPage: React.FC<PageProps> = ({ pageContext, location }: any) => {
  // Show Confirm Zip Modal if zip has not been confirmed
  const [{}, dispatchConfirmZip] = useContext(ConfirmZipContext)

  const [{ zip }] = useContext(LocationContext)
  useEffect(() => {
    const zipIsConfirmed = LocalStorageClient.read("confirmedZip")
    if (zipIsConfirmed != true) {
      dispatchConfirmZip(openConfirmZipModal())
    }
  }, [zip])

  const customSchema = `{
  "@context": "http://schema.org",
  "@type": "Organization",
  "name": "${
    pageContext.name !== ""
      ? `Southeast Toyota Dealers ${pageContext.name} Inventory`
      : `Southeast Toyota Dealers Inventory`
  }",
  "description": "Find available Toyota Inventory in Alabama, Florida, Georgia, South Carolina, and North Carolina.",
  "image": "https://cdn.sanity.io/images/90qxor39/production/0f9ca8ddd20b283fa6289bc934bcd09c572835af-1900x1072.jpg?q=75&fit=max&auto=format&dpr=0.75",
  "logo": "https://cdn.sanity.io/images/90qxor39/production/027c7daf74a2f6ed4dbb6affc4d848a5d610eb2b-1958x397.png?q=75&fit=max&auto=format&dpr=0.75",
  "url": "${location.href}",
  "sameAs": ["https://x.com/ExploreSEToyota?mx=2","https://www.pinterest.com/exploresetoyota/","https://www.facebook.com/exploresetoyota/","https://www.youtube.com/c/LocalToyotaDealers","https://www.instagram.com/exploresetoyota/"],
  "address": {
  "@type": "PostalAddress",
    "addressCountry": "United States of America"
    }
  }`

  return (
    <Layout tealium={{ label: "inventoryPage" }}>
      <SEO
        url={location.href}
        title={`Toyota ${pageContext?.name ? pageContext.name : ""} Inventory`}
        schema={customSchema}
      />
      <ConfirmZipModal fromInventory />
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={true} />
        <FamilySeriesProvider>
          <FamilySeries series={pageContext.slug} />
        </FamilySeriesProvider>
        <FiltersProvider>
          <Inventory
            series={pageContext.name}
            category={pageContext.category}
            name={pageContext.name}
          />
        </FiltersProvider>
      </QueryClientProvider>
    </Layout>
  )
}

export default InventoryPage
